import styled from 'styled-components';
import { Modal } from 'antd';

export const Wrapper = styled.div`
  .login-box {
    box-shadow: 0 0.1rem 1rem 0.25rem rgb(0 0 0 / 5%) !important;
    .ant-form {
      .ant-form-item-label {
        label {
          width: 100%;
          color: #181c32;
          font-weight: 600;
          font-size: 1.075rem;
        }
      }
    }
  }
`;

export const ModalStyled = styled(Modal)`
  .ant-modal-content {
    border-radius: 20px;
    overflow: hidden;
    .otp-wrapper {
      display: flex;
      justify-content: center;
      > div {
        display: flex;
        gap: 1rem;
        > div {
          input {
            border: 1px solid grey;
            width: 3rem !important;
            height: 3rem !important;
            border-radius: 0.5rem;
            color: #181c32 !important;
            font-size: 1.5rem;
          }
        }
      }
    }
  }
`;
